import { defineComponent } from "vue";

import { COMPONENT_NAME, SVG } from "./attributes";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    headerSvg: {
      type: String,
      default: "",
    },
    headerTitle: {
      type: String,
      default: "",
    },
    headerView: {
      type: String,
      default: "",
    },
    footerTitle: {
      type: String,
      default: "",
    },
    isTerms: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    displayedSvg(): string {
      return SVG[this.headerSvg];
    },
  },
});
